import { CHECKOUT_CUSTOMER_SUPPORT } from '@finn/ua-tracking';
import { trackEvent } from '@finn/ui-utils';

type AnyRecord = Record<string, string | number>;
export const supportNavbarClicked = (props?: AnyRecord) => {
  trackEvent(CHECKOUT_CUSTOMER_SUPPORT.SUPPORT_NAVBAR_CLICKED, {
    ...props,
  });
};
